const week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

const forwardCss = `
    font-size: 12px;
    background:#efefef;
    width: 90%;
    padding: 6px 8px;
    border-radius: 6px;
    margin: 10px 0
`

/** 回复和转发邮件初始头部信息 */
export const getDivider = (
	emailFrom: string,
	date: Date,
	type?: boolean,
	subject?: string,
	to?: string
) => {
	if (!type) {
		/** 回复邮件 */
		return `<div style="font-size: 13px;">On ${week[date.getDay()]}, ${
			month[date.getMonth()]
		} ${date.getDate()}, ${date.getFullYear()} at ${date.getHours() % 12 || 12}:${
			date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
		} ${date.getHours() >= 12 ? 'PM' : 'AM'} ${emailFrom
			.replace('<', '&lt;')
			.replace('>', '&gt;')} wrote:</div>`
	} else {
		/** 转发邮件 */
		return `<div style="font-size: 13px;">---------- Forwarded Message ----------</div>
      <div style="${forwardCss}">
        From: ${emailFrom.replace('<', '&lt;').replace('>', '&gt;')}<br/>
        Date: ${week[date.getDay()]}, ${
			month[date.getMonth()]
		} ${date.getDate()}, ${date.getFullYear()} at ${date.getHours() % 12 || 12}:${
			date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
		} ${date.getHours() >= 12 ? 'PM' : 'AM'}<br/>
        Subject: ${subject}<br/>
        To: ${to?.replace('<', '&lt;')?.replace('>', '&gt;')}
      </div>`
	}
}

export const extractBlockquote = (html: string) => {
	const parser = new DOMParser()
	const doc = parser.parseFromString(html, 'text/html')

	/** Blockquote */
	const allBlockquotes = Array.from(doc.querySelectorAll('blockquote'))

	/** 提取正文去掉最外层Blockquote */
	let bodyContent = ''
	const firstBlockquote = allBlockquotes[0]
	if (firstBlockquote) {
		// clone body
		const cloned = doc.body.cloneNode(true) as HTMLElement
		const blockquoteInClone = cloned.querySelector('blockquote')
		if (blockquoteInClone) {
			blockquoteInClone.remove()
		}
		bodyContent = cloned.innerHTML.trim()
	} else {
		bodyContent = doc.body.innerHTML.trim()
	}

	/** 提取最外层Blockquote */
	let outer = ''
	let inner = ''
	if (firstBlockquote) {
		outer = firstBlockquote.innerHTML.trim()

		let nested = firstBlockquote.querySelector('blockquote')
		inner = outer
		while (nested) {
			inner = nested.innerHTML.trim()
			nested = nested.querySelector('blockquote')
		}
	}

	return { body: bodyContent, outer, inner }
}

/** 格式化回复标识，避免多次回复叠加Re/Fwd这些 */
export const formatSubjectPrefix = (subject: string, type: 'RE' | 'FWD') => {
	if (!subject) return ''

	const prefix = type === 'RE' ? 'Re:' : 'Fwd:'

	/** 去掉开头所有重复前缀 */
	const regex = new RegExp(`^((${prefix}\\s*)+)?`, 'i')
	const cleanSubject = subject.replace(regex, '').trim()

	return `${prefix} ${cleanSubject}`
}

/**
 *  - 统一包裹邮件内容（兼容Outlook/Gmail/AppleMail）
 *  - html 原始 HTML 字符串
 *  - options 控制项
 *  - quote: 是否是引用内容（加左边竖线）
 *  - color: 文本颜色（默认 #1d2129）
 */
export const wrapMailHTML = (
	html: string,
	options: {
		quote?: boolean
		color?: string
		fontSize?: number
		lineHeight?: number
		marginBottom?: number
	} = {}
) => {
	const {
		quote = false,
		color = '#1d2129',
		fontSize = 13,
		lineHeight = 1.2,
		marginBottom = 10
	} = options

	const baseStyle = `
		white-space: pre-wrap;
		font-family: Arial, Helvetica, sans-serif;
		font-size: ${fontSize}px;
		line-height: ${lineHeight};
		color: ${color};
		margin: 0 0 ${marginBottom}px 0;
		padding: 0;
		mso-line-height-rule: exactly;
		word-break: break-word;
	`

	if (quote) {
		return `
			<blockquote
				style="
					border-left: 2px solid #ccc;
					margin: 8px 0 0 0;
					padding-left: 8px;
					color: #555;
					mso-line-height-rule: exactly;
				"
			>
				<div style="${baseStyle}">
					${html}
				</div>
			</blockquote>
		`
	}

	return `<div style="${baseStyle}">${html}</div>`
}
